import React, { CSSProperties } from "react"
import { ThemeIcon } from "@humanpredictiveintelligence/myqvt-library"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"

import { ThemeQuestionWithTheme } from "features/Surveys/CustomSurveys/models"
import * as Styles from "./SortableQuestion.styles"

export const SortableQuestion: React.FC<SortableQuestionProps> = (props) => {
  const {
    attributes,
    isDragging,
    listeners,
    setDroppableNodeRef,
    transform,
    transition,
    setDraggableNodeRef,
  } = useSortable({
    id: props.question.id,
  })

  const style: CSSProperties = {
    opacity: isDragging ? 0.4 : undefined,
    transform: CSS.Translate.toString(transform),
    transition,
  }

  return (
    <Styles.Container
      style={style}
      ref={setDroppableNodeRef}
      {...attributes}
    >
      <Styles.Question.LabelAndHandel>
        <div {...listeners} ref={setDraggableNodeRef}>
          <Styles.Question.DragHandle
            isDisabled={props.isReadOnly}
            name="drag_indicator"
            size={32}
          />
        </div>
        {props.question.theme && (
          <ThemeIcon
            icon={props.question.theme.icon}
            name={props.question.theme.name}
            color={props.question.theme.color}
          />
        )}
        <Styles.Question.Label>Question {props.questionIndex + 1}</Styles.Question.Label>
      </Styles.Question.LabelAndHandel>
      <Styles.Question.NameAndChoices>
        <Styles.Question.Name>{props.question.name}</Styles.Question.Name>
        <Styles.Question.Choices questionId={props.question.id} />
      </Styles.Question.NameAndChoices>
      <Styles.Question.RemoveAction
        icon="close"
        isDisabled={props.isReadOnly}
        onClick={() => props.onRemove()}
        isDestructive
      />
    </Styles.Container>
  )
}

interface SortableQuestionProps {
  questionIndex: number,
  question: ThemeQuestionWithTheme,
  onRemove: () => void,
  isReadOnly: boolean,
}
